module.exports = __webpack_public_path__ + "media/images/partner/safezone-9bb9795504bca984956f9b4648acce03.png";